<template>
    <div class="flex items-center justify-center">
        <BackButton class="md:mr-8" />
        <BaseButton
            v-if="onlyDesktopVisible"
            key="table-of-contents-button"
            :tooltip="localizations[lang].tooltips.tableOfContents"
            :class="[ui.tableOfContents.opened ? 'header-btn-active' : 'text-theme-icon', 'block']"
            dusk="buttonTableOfContents"
            type="button"
            icon="baseline-view_list-24px"
            :aria-expanded="String(ui.tableOfContents.opened)"
            @click="toggleTableOfContents"
        />

        <BaseButton
            v-if="onlyDesktopVisible && isPdf"
            v-show="ui.thumbnails.enabled"
            key="thumbnails-button"
            :tooltip="localizations[lang].tooltips.openThumbnails"
            :class="[ui.thumbnails.opened ? 'header-btn-active' : 'text-theme-icon', 'block']"
            dusk="buttonThumbnails"
            icon="baseline-apps-24px"
            :aria-expanded="String(ui.thumbnails.opened)"
            @click="toggleThumbnails"
        />

        <BaseButton
            v-if="onlyDesktopVisible && !isAudiobook"
            key="notebook-button-desktop"
            :tooltip="localizations[lang].notebook"
            :class="[ui.notebook.opened ? 'header-btn-active' : 'text-theme-icon', 'block']"
            type="button"
            :disabled="isOfflineOnRemoteContent"
            data-cy="buttonNotebook"
            icon="outline-description-24px"
            dusk="buttonNotebook"
            :aria-expanded="String(ui.notebook.opened)"
            @click="toggleNotebook"
        />

        <BaseButton
            v-if="onlyDesktopVisible && canUseFlashcards"
            key="flashcards-button-desktop"
            :tooltip="localizations[lang].flashcards"
            :class="[ui.flashcardsPanel.opened ? 'header-btn-active' : 'text-theme-icon', 'block']"
            type="button"
            :disabled="isOfflineOnRemoteContent"
            data-cy="buttonFlashcards"
            icon="flashcard-24px"
            dusk="buttonFlashcards"
            :aria-expanded="String(ui.flashcardsPanel.opened)"
            @click="toggleFlashcardsPanel"
        />

        <BaseButton
            v-if="onlyDesktopVisible && canUseAddOns"
            key="add-ons-button-desktop"
            :tooltip="addOnsTitle"
            :class="[ui.addOnsPanel.opened ? 'header-btn-active' : 'text-theme-icon', 'block']"
            type="button"
            icon="squares-plus-24px"
            dusk="buttonAddOns"
            :aria-expanded="String(ui.addOnsPanel.opened)"
            @click="toggleAddOnsPanel"
        />

        <template v-if="onlyDesktopVisible && canUseReaderPlugins">
            <BaseButton
                v-for="plugin in shownReaderPlugins"
                :key="`plugin-button-desktop-${plugin.key}`"
                :tooltip="plugin.title"
                :class="[isReaderPluginOpen(plugin.key) ? 'header-btn-active' : 'text-theme-icon', 'block']"
                type="button"
                :disabled="isOffline"
                :icon="plugin.icon"
                :dusk="`buttonPlugin-${plugin.key}`"
                :aria-expanded="String(isReaderPluginOpen(plugin.key))"
                :data-reader-plugin-button="plugin.key"
                @click="togglePlugin(plugin.key)"
            />
        </template>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseButton from '../Components/buttons/BaseButton.vue';
import BackButton from '../Components/buttons/BackButton.vue';
import { addOnStrings } from '../AddOns/addOnStrings.js';

export default {
    components: {
        BaseButton,
        BackButton,
    },
    computed: {
        ...mapState(['ui', 'publication', 'localizations', 'lang', 'isOffline']),
        ...mapGetters([
            'isPdf',
            'isAudiobook',
            'isEmbeddedMode',
            'onlyDesktopVisible',
            'onlyMobileVisible',
            'isOfflineOnRemoteContent',
            'canUseReaderPlugins',
            'shownReaderPlugins',
            'isReaderPluginOpen',
            'canUseFlashcards',
            'canUseAddOns',
        ]),
        addOnsTitle() {
            return addOnStrings(this.localizations, this.lang).title;
        },
    },
    methods: {
        ...mapActions([
            'toggleTableOfContents',
            'toggleThumbnails',
            'toggleNotebook',
            'toggleFlashcardsPanel',
            'toggleAddOnsPanel',
            'togglePlugin',
        ]),
    },
};
</script>
